import { RestrictedAccountObjectApiFacade } from "../restricted-account-object/restricted-account-object.api-facade";
import { Control } from "./control.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class ControlApiFacade extends RestrictedAccountObjectApiFacade<Control> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Control> {
        return this.GET(`/accounts/${accountId}/controls/${id}`, options)
            .map(object => new Control({
                account: accountId,
                ...object
            }));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Control>> {
        return this.CGET(`/accounts/${accountId}/controls`, options)
            .map(objects => objects.map(object => new Control({
                account: accountId,
                ...object
            })));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control.api-facade.ts